
import { Component, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import productOptionMixin from '@/mixin/productOptionStatus'
import currencyOptionMixin from '@/mixin/currencyOption'
import orderDateOptionMixin from '@/mixin/orderDateOption'
import {
  getOrderList,
  orderExport,
  setUnpaidOrder,
  setPaidOrder,
  depositOrderStatistical,
  batchOrderCap,
  depositRefund,
  getOrderSubProduct
} from '@/api/order/deposit'
import { Form as ElForm } from 'element-ui'
import { notifiedStatusList } from '@/utils/constant'
import { AppModule } from '@/store/modules/app'
import orderDetail from './components/depositDetail.vue'
import { delObjEmptyKey, jsonToObjArr } from '@/utils'
import { setOrderStatusRules } from '@/utils/rules'
import { checkNeedAudit, checkPermission } from '@/utils/permission'
import { operationMessage } from '@/utils/message'
import { getCurrentDate, dateToSeconds } from '@/utils/dateTime'
import PicsUploader from '@/components/PicsUploader/index.vue'
import depositBatchNotify from './components/depositBatchNotify.vue'
import { getAccountGroupList } from '@/api/product/accountGroup'
import kick from './components/kickOut.vue'
import { getType } from '@/utils/cookies'
import { setBatchRefund } from '@/api/order/refund'
import { setOneClickChange } from '@/api/task/withdraw'
import { getProductAccountList } from '@/api/product/productAccount'

@Component({
  name: 'depositList',
  components: {
    orderDetail,
    PicsUploader,
    depositBatchNotify,
    kick
  }
})
export default class extends mixins(
  productOptionMixin,
  currencyOptionMixin,
  orderDateOptionMixin
) {
  queryForm: any = {
    upstream_remarks: null,
    auth_code: null,
    last4: null,
    merchant_no: null,
    order_number: null,
    ant_username: null,
    status: null,
    upstream_status: null,
    notify_status: null,
    product: null,
    min_amount: '',
    max_amount: '',
    min_request_amount: '',
    max_request_amount: '',
    start_time: null,
    end_time: null,
    notify_start_time: null,
    notify_end_time: null,
    product_name: null,
    product_account_name: null,
    success_start_time: null,
    success_end_time: null,
    product_type: 'deposit',
    product_account_group: null,
    test_order: null,
    kaaz_bank: '',
    pay_time_duration: null
  }

  private enterpriseId: any = AppModule.enterprise.id

  private amountType: string = 'Request Amount'
  private statusList: any[] = []
  private notifiedStatusList = notifiedStatusList
  private instruction: any[] = []
  private orderStatusList: any[] = []
  private upstreamStatusList: any[] = []
  private sendLoading: boolean = false
  private orderList: any[] = []
  private listLoading: Boolean = false
  private totalData: any = {}
  // private total = {}
  private total = 0

  private dialogVisible: boolean = false
  private setForm: any = {}
  private payTime: any = ''
  private selectList: any[] = []
  private ordernumbers: any[] = []
  private dialogVisible1: boolean = false

  private rules = setOrderStatusRules
  private loading: boolean = false

  private currentOrdernumber: number | null = null
  private drawer: boolean = false
  private fixTime: any = null
  private sysType: any = ''

  private payRules = {
    google_code: [
      { required: true, message: 'Please input Google Code', trigger: 'blur' }
    ]
  }

  setFormUnfreeze: any = {
    currency: '',
    status: null,
    remarks: null,
    google_code: ''
  }

  @Watch('queryForm.currency', { immediate: true })
  private watchCurrency() {
    this.setFormUnfreeze.currency = this.queryForm.currency
  }

  // 一键更改
  private opnekickUnfreezeShow: boolean = false
  private multilength: any = []
  private requiredErr: any = ''
  private requiredRemarks: any = ''
  private requiredStatus: any = ''

  private changeOrder(val: any) {
    if (val) {
      let str = val.replace(/\n|\r\n/g, ',')
      let str1 = false
      str1 = str.includes('，')
      if (str1) {
        str = val.replace(/\，/g, ',')
      }
      // 转成数组并去掉空值
      this.multilength = str.split(',')
      this.multilength = this.multilength.filter((item: any) => {
        return item !== ''
      })
      let pattern = /([。！？；,.!?;，])\1$/
      if (pattern.test(str)) {
        let newStr = str.replace(pattern, '')
        this.queryForm.multi_order_number = newStr.split(',').join(',')
      } else {
        this.queryForm.multi_order_number = str.split(',').join(',')
      }
    } else {
      this.multilength = []
    }
  }

  private opnekickUnfreeze() {
    this.opnekickUnfreezeShow = true
    this.ordernumbers = []
    for (let i = 0; i < this.selectList.length; i++) {
      this.ordernumbers.push(this.selectList[i].ordernumber)
    }
    if (this.ordernumbers) {
      let arr = this.ordernumbers
      this.multilength = arr
      this.queryForm.multi_order_number = arr.join(',')
    }
    this.setFormUnfreeze.status = null
    this.setFormUnfreeze.remarks = null
    this.setFormUnfreeze.google_code = ''
    this.requiredErr = ''
    this.requiredRemarks = ''
    this.requiredStatus = ''
    if (this.dateType === 'Created Time' && !this.date) {
      this.date = getCurrentDate()
    }
    if (this.dateType === 'Success Time' && !this.successDate) {
      this.successDate = getCurrentDate()
    }
  }

  private closeOpnekickUnfreeze() {
    this.opnekickUnfreezeShow = false
    this.setFormUnfreeze.status = null
    this.setFormUnfreeze.remarks = null
    this.setFormUnfreeze.google_code = ''
    this.queryForm.multi_order_number = ''
    this.multilength = ''
  }

  private changeStatus() {
    this.setFormUnfreeze.status = null
  }

  private async saveClickChange() {
    ;(this.$refs.setFormUnfreeze as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true
        this.flag = true
        if (
          this.queryForm.multi_order_number &&
          this.queryForm.multi_order_number.substr(-1) === ','
        ) {
          this.queryForm.multi_order_number =
            this.queryForm.multi_order_number.replace(/\S{1}$/, '')
        }
        const data: any = {
          ...this.setFormUnfreeze,
          filters: {
            order_number: this.queryForm.order_number,
            merchant_no: this.queryForm.merchant_no,
            min_amount: this.queryForm.min_amount,
            max_amount: this.queryForm.max_amount,
            product_code: this.queryForm.product_code,
            product_account_no: this.queryForm.product_account_no,
            product_account_group: this.queryForm.product_account_group,
            status: this.queryForm.status,
            upstream_status: this.queryForm.upstream_status,
            reverse_order: this.queryForm.reverse_order,
            notify_status: this.queryForm.notify_status,
            start_time: this.queryForm.start_time,
            end_time: this.queryForm.end_time,
            success_start_time: this.queryForm.success_start_time,
            success_end_time: this.queryForm.success_end_time,
            multi_order_number: this.queryForm.multi_order_number,
            product_type: 'deposit'
          }
        }
        delObjEmptyKey(data)
        await setOneClickChange(data)
          .then(() => {
            this.$message({
              message: 'Operation successfully!',
              type: 'success'
            })
            this.loading = false
            this.flagStr()
            this.closeOpnekickUnfreeze()
            this.select()
          })
          .catch(() => {
            this.loading = false
            this.flagStr()
          })
      }
    })
  }

  // USD 批量退款
  private batchRefundVisble: boolean = false
  private batchRefundList: any[] = []
  private batchRefundArr: any[] = []
  private batchRefundErrList: any[] = []
  private batchRefundErrVisble: boolean = false
  private refundloading: boolean = false
  private timer: any = null
  private batchRefundForm: any = {
    ordernumbers: '',
    google_code: ''
  }
  private openBatchRefund() {
    this.batchRefundArr = []
    for (let i = 0; i < this.batchRefundList.length; i++) {
      if (this.batchRefundList[i].status === 1) {
        this.batchRefundArr.push(this.batchRefundList[i].ordernumber)
      }
    }
    this.batchRefundForm.ordernumbers = this.batchRefundArr.join(',')
    if (this.$store.state.app.enterprise.google_auth_switch) {
      this.batchRefundVisble = true
    } else {
      this.onBatchRefund()
    }
  }

  private async onBatchRefund() {
    this.refundloading = true
    const data: any = {
      ...this.batchRefundForm
    }
    await setBatchRefund(data)
      .then((res: any) => {
        this.$message.success('Successful operation!')
        this.timer = setTimeout(() => {
          this.refundloading = false
        }, 1000)
        if (res.errors) {
          this.batchRefundErrVisble = true
          this.batchRefundErrList = res.errors
        }
      })
      .catch(() => {
        this.refundloading = false
      })
  }
  private closeBatchRefund() {
    this.batchRefundVisble = false
    this.hadleGetFilesListApi()
    this.batchRefundForm = {
      ordernumbers: '',
      google_code: ''
    }
    clearTimeout(this.timer)
  }

  private closeBatchRefundErr() {
    this.batchRefundErrVisble = false
    this.batchRefundErrList = []
  }

  // 跳转地址
  private jumpAddress(row, type, network) {
    if (type === 'trc20') {
      window.open(`https://tronscan.io/#/address/${row}/transfers`)
    } else if (type === 'erc20') {
      window.open(`https://etherscan.io/address/${row}`)
    } else if (type === 'usdc_erc20') {
      window.open(`https://etherscan.io/address/${row}`)
    }
    if (network === 'ethereum') {
      window.open(`https://etherscan.io/address/${row}`)
    } else if (network === 'solana') {
      window.open(`https://solscan.io/account/${row}`)
    } else if (network === 'polygon') {
      window.open(`https://polygonscan.com/address/${row}`)
    } else if (network === 'bsc') {
      window.open(`https://bscscan.com/address/${row}`)
    } else if (network === 'btc') {
      window.open(`https://www.blockchain.com/explorer/addresses/btc/${row}`)
    } else if (network === 'avalanche') {
      window.open(`https://avascan.info/blockchain/c/address/${row}`)
    } else if (network === 'tron') {
      window.open(`https://tronscan.io/#/address/${row}`)
    } else if (type === 'ton') {
      window.open(`https://tonscan.org/address/${row}`)
    }
  }

  private jumpUSDCAddress(row, type) {
    if (type === 'ethereum') {
      window.open(`https://etherscan.io/address/${row}`)
    } else if (type === 'solana') {
      window.open(`https://solscan.io/account/${row}`)
    } else if (type === 'polygon') {
      window.open(`https://polygonscan.com/address/${row}`)
    } else if (type === 'bsc') {
      window.open(`https://bscscan.com/address/${row}`)
    } else if (type === 'btc') {
      window.open(`https://www.blockchain.com/explorer/addresses/btc/${row}`)
    } else if (type === 'avalanche') {
      window.open(`https://avascan.info/blockchain/c/address/${row}`)
    } else if (type === 'tron') {
      window.open(`https://tronscan.io/#/address/${row}`)
    } else if (type === 'ton') {
      window.open(`https://tonscan.org/address/${row}`)
    }
  }

  private bit2goJump(row, type) {
    if (type === 'usdt_bit2go_erc20') {
      window.open(`https://etherscan.io/address/${row}`)
    } else if (type === 'usdt_bit2go_trc20') {
      window.open(`https://tronscan.io/#/address/${row}`)
    }
  }

  private hashJump(row) {
    if (row.product_account_type === 'trc20') {
      window.open(
        `https://tronscan.io/#/transaction/${row.upstream_ordernumber}`
      )
    } else if (row.product_account_type === 'erc20') {
      window.open(`https://etherscan.io/tx/${row.upstream_ordernumber}`)
    }
    const upstream_notify = row.upstream_notify
    if (upstream_notify.network === 'ethereum') {
      window.open(`https://etherscan.io/tx/${row.upstream_ordernumber}`)
    } else if (upstream_notify.network === 'solana') {
      window.open(`https://solscan.io/tx/${row.upstream_ordernumber}`)
    } else if (upstream_notify.network === 'polygon') {
      window.open(`https://polygonscan.com/tx/${row.upstream_ordernumber}`)
    } else if (upstream_notify.network === 'bsc') {
      window.open(`https://bscscan.com/tx/${row.upstream_ordernumber}`)
    } else if (upstream_notify.network === 'btc') {
      window.open(
        `https://www.blockchain.com/explorer/transactions/btc/${row.upstream_ordernumber}`
      )
    } else if (upstream_notify.network === 'avalanche') {
      window.open(
        `https://avascan.info/blockchain/c/tx/${row.upstream_ordernumber}`
      )
    } else if (upstream_notify.network === 'tron') {
      window.open(
        `https://tronscan.io/#/transaction/${row.upstream_ordernumber}`
      )
    }
  }

  private channelJump(v, address) {
    if (v === 'ethereum') {
      window.open(`https://etherscan.io/address/${address}`)
    } else if (v === 'solana') {
      window.open(`https://solscan.io/account/${address}`)
    } else if (v === 'polygon') {
      window.open(`https://polygonscan.com/address/${address}`)
    } else if (v === 'bsc') {
      window.open(`https://bscscan.com/address/${address}`)
    } else if (v === 'btc') {
      window.open(
        `https://www.blockchain.com/explorer/addresses/btc/${address}`
      )
    } else if (v === 'avalanche') {
      window.open(`https://avascan.info/blockchain/c/address/${address}`)
    } else if (v === 'tron') {
      window.open(`https://tronscan.io/#/address/${address}`)
    }
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  // 对所有数据进行分页处理 发送请求
  private async hadleGetFilesListApi() {
    try {
      this.listLoading = true
      const data: any = {
        ...this.queryForm,
        page_size: this.pagesize,
        page: this.currentPage
      }
      this.orderList = []
      await getOrderList(data).then((res: any) => {
        // this.orderList = res.results
        this.orderList = this.handleContentText(res.results)
        this.total = res.count
        this.listLoading = false
        this.currentPage = this.currentPage
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  private handleContentText(list: any[]) {
    return list.map((item: any) => {
      const remarks: string = item.upstream_remarks
      const type: string = item.product_account_type

      if (!remarks || !type) return item

      // 处理不同类型的地址跳转
      if (['trc20', 'erc20', 'usdc_erc20', 'usdc_trc20'].includes(type)) {
        item.upstream_remarks = this.processStandardCryptoRemarks(remarks, item)
      } else if (type === 'usdc_bit2go') {
        item.upstream_remarks = this.processUSDCBitGoRemarks(remarks, item)
      } else if (type === 'usdt_bit2go') {
        item.upstream_remarks = this.processUSDTBitGoRemarks(remarks, item)
        // console.log(remarks)
        // console.log(item.upstream_remarks, '123123')
      } else if (['usdt_bit2go_erc20', 'usdt_bit2go_trc20'].includes(type)) {
        item.upstream_remarks = this.processBit2GoERC20TRC20Remarks(
          remarks,
          item
        )
      }

      return item
    })
  }

  // 处理标准加密货币备注
  private processStandardCryptoRemarks(remarks: string, item: any): string {
    return remarks
      .split('_')
      .map((str: any) => {
        if (str.includes('Generate Address')) {
          const parts = str.split('Generate Address', 2)
          const addressPart = parts[1]?.split('(', 2)[1]?.split(')', 2)[0] || ''

          return `<span>Generate Address(</span>
              <span onclick="jumpAddress('${item.wallet_address}','${
            item.product_account_type
          }','${
            item.upstream_notify ? item.upstream_notify.network : ''
          }')" style="color:#1890ff;cursor:pointer;">${addressPart}</span><span>)</span>`
        }
        return str
      })
      .join('_')
  }

  // 处理 USDC BitGo 备注
  private processUSDCBitGoRemarks(remarks: string, item: any): string {
    return remarks
      .split('_')
      .map((str: any) => {
        if (str.includes('Generate Address')) {
          const addressPart =
            str
              .split('Generate Address', 2)[1]
              ?.split('(', 2)[1]
              ?.split(')', 2)[0] || ''

          try {
            const addresses = JSON.parse(addressPart.replace(/'/g, '"'))
            const {
              ethereum,
              polygon,
              bsc,
              solana,
              btc,
              avalanche,
              tron,
              ton
            } = addresses

            const addressElements: any[] = []
            if (ethereum)
              addressElements.push(
                `<span style="font-weight:600">ethereum:</span><span style="color:#1890ff;cursor:pointer;" onclick="jumpUSDCAddress('${ethereum}','ethereum')">${ethereum}</span>`
              )
            if (polygon)
              addressElements.push(
                `<span style="font-weight:600">polygon:</span><span style="color:#1890ff;cursor:pointer;" onclick="jumpUSDCAddress('${polygon}','polygon')">${polygon}</span>`
              )
            if (bsc)
              addressElements.push(
                `<span style="font-weight:600">bsc:</span><span style="color:#1890ff;cursor:pointer;" onclick="jumpUSDCAddress('${bsc}','bsc')">${bsc}</span>`
              )
            if (solana)
              addressElements.push(
                `<span style="font-weight:600">solana:</span><span style="color:#1890ff;cursor:pointer;" onclick="jumpUSDCAddress('${solana}','solana')">${solana}</span>`
              )
            if (btc)
              addressElements.push(
                `<span style="font-weight:600">btc:</span><span style="color:#1890ff;cursor:pointer;" onclick="jumpUSDCAddress('${btc}','btc')">${btc}</span>`
              )
            if (avalanche)
              addressElements.push(
                `<span style="font-weight:600">avalanche:</span><span style="color:#1890ff;cursor:pointer;" onclick="jumpUSDCAddress('${avalanche}','avalanche')">${avalanche}</span>`
              )
            if (tron)
              addressElements.push(
                `<span style="font-weight:600">tron:</span><span style="color:#1890ff;cursor:pointer;" onclick="jumpUSDCAddress('${tron}','tron')">${tron}</span>`
              )
            if (ton)
              addressElements.push(
                `<span style="font-weight:600">ton:</span><span style="color:#1890ff;cursor:pointer;" onclick="jumpUSDCAddress('${ton}','ton')">${ton}</span>`
              )

            return `<span>Generate Address(${addressElements.join(',')})</span>`
          } catch (e) {
            return str
          }
        }
        return str
      })
      .join('_')
  }

  // 处理 USDT BitGo 备注
  private processUSDTBitGoRemarks(remarks: string, item: any): string {
    return remarks
      .split(')_')
      .map((str: any) => {
        if (str.includes('Generate Address')) {
          const addressPart =
            str
              .split('Generate Address', 2)[1]
              ?.split('(', 2)[1]
              ?.split(')', 2)[0] || ''

          try {
            const addresses = JSON.parse(addressPart.replace(/'/g, '"'))
            const {
              ethereum,
              polygon,
              bsc,
              solana,
              btc,
              avalanche,
              tron,
              ton
            } = addresses
            // console.log(addresses)

            const addressElements: any[] = []
            if (tron)
              addressElements.push(
                `<span style="font-weight:600">tron:</span><span style="color:#1890ff;cursor:pointer;" onclick="jumpUSDCAddress('${tron}','tron')">${tron}</span>`
              )
            if (ton)
              addressElements.push(
                `<span style="font-weight:600">ton:</span><span style="color:#1890ff;cursor:pointer;" onclick="jumpUSDCAddress('${ton}','ton')">${ton}</span>`
              )
            if (ethereum)
              addressElements.push(
                `<span style="font-weight:600">ethereum:</span><span style="color:#1890ff;cursor:pointer;" onclick="jumpUSDCAddress('${ethereum}','ethereum')">${ethereum}</span>`
              )
            if (polygon)
              addressElements.push(
                `<span style="font-weight:600">polygon:</span><span style="color:#1890ff;cursor:pointer;" onclick="jumpUSDCAddress('${polygon}','polygon')">${polygon}</span>`
              )
            if (bsc)
              addressElements.push(
                `<span style="font-weight:600">bsc:</span><span style="color:#1890ff;cursor:pointer;" onclick="jumpUSDCAddress('${bsc}','bsc')">${bsc}</span>`
              )
            if (solana)
              addressElements.push(
                `<span style="font-weight:600">solana:</span><span style="color:#1890ff;cursor:pointer;" onclick="jumpUSDCAddress('${solana}','solana')">${solana}</span>`
              )
            if (btc)
              addressElements.push(
                `<span style="font-weight:600">btc:</span><span style="color:#1890ff;cursor:pointer;" onclick="jumpUSDCAddress('${btc}','btc')">${btc}</span>`
              )
            if (avalanche)
              addressElements.push(
                `<span style="font-weight:600">avalanche:</span><span style="color:#1890ff;cursor:pointer;" onclick="jumpUSDCAddress('${avalanche}','avalanche')">${avalanche}</span>`
              )
            console.log(addressElements)

            return `<span>Generate Address(${addressElements.join(',')})</span>`
          } catch (e) {
            return str
          }
        }
        return str
      })
      .join('_')
  }

  // 处理 Bit2Go ERC20/TRC20 备注
  private processBit2GoERC20TRC20Remarks(remarks: string, item: any): string {
    return remarks
      .split('_')
      .map((str: any) => {
        if (str.includes('Generate Address')) {
          const addressPart =
            str
              .split('Generate Address', 2)[1]
              ?.split('(', 2)[1]
              ?.split(')', 2)[0] || ''

          return `<span>Generate Address(</span>
              <span onclick="bit2goJump('${item.extra_param?.address || ''}','${
            item.product_account_type
          }','')"
              style="color:#1890ff;cursor:pointer;">${addressPart}</span><span>)</span>`
        }
        return str
      })
      .join('_')
  }

  private isDisabled(row, index) {
    return row.status === 1 && row.notify_status !== 1
  }

  private handleSelectionChange(list) {
    this.selectList = list
    this.batchRefundList = list
  }

  private changeAmount() {
    this.queryForm.min_request_amount = null
    this.queryForm.max_request_amount = null
    this.queryForm.min_amount = null
    this.queryForm.max_amount = null
  }

  get authCode() {
    return this.setForm.oldStatus === 1
      ? 'change_paid_deposit_order_status'
      : 'change_unpaid_deposit_order_status'
  }

  // 上传图片
  private getPicList(fileList: any) {
    this.setForm.attach = fileList.map((item: any) => {
      if (item.response) {
        return item.response.file_path
      } else {
        return item.url
      }
    })
  }

  private isCanSet(info: any) {
    return info.status === 1
      ? checkPermission('change_paid_deposit_order_status')
      : checkPermission('change_unpaid_deposit_order_status')
  }

  private orderSubProductList: any = []
  private async getSubProduct(val) {
    const data = {
      merchant_id: val.merchant_no,
      parent_product_id: val.product
    }
    await getOrderSubProduct(data).then((res: any) => {
      this.orderSubProductList = res.sub_products
    })
  }

  private async openDialog(info: any) {
    await this.checkChildProduct()
    this.setForm = {
      ...info,
      oldStatus: info.status,
      status: null,
      paid_time: null,
      upstream_ordernumber: null,
      product_sub_code: info.extra_param.product_sub_code
    }
    this.fixTime = null
    this.dialogVisible = true
    await this.getSubProduct(info)
  }

  private subProductList: any = []
  private isSubbProduct: boolean = false
  // 修改订单查询是否存在子产品
  private async checkChildProduct() {
    this.subProductList = []
    if (this.inProductList.length > 0) {
      const matchedProduct = this.inProductList.find(
        (item: any) => item.name === this.setForm.product_code
      )
      if (matchedProduct && matchedProduct.extra_param.product_sub_rate_list) {
        this.subProductList = matchedProduct.extra_param.product_sub_rate_list
        this.isSubbProduct = true
      } else {
        this.subProductList = []
        this.isSubbProduct = false
      }
    }
  }

  // 批量发送订单回调
  private openDialog1() {
    this.ordernumbers = []
    for (let i = 0; i < this.selectList.length; i++) {
      this.ordernumbers.push(this.selectList[i].ordernumber)
    }
    this.dialogVisible1 = true
  }

  private closeDialog() {
    this.dialogVisible = false
    this.opnekickOut = false
    this.hadleGetFilesListApi()
  }

  private closeDialog1() {
    this.dialogVisible1 = false
    this.hadleGetFilesListApi()
  }

  // 踢出队列
  private opnekickOut: boolean = false
  private openKickOut() {
    this.ordernumbers = []
    for (let i = 0; i < this.selectList.length; i++) {
      if (this.selectList[i].is_in_queue !== null) {
        this.ordernumbers.push(this.selectList[i].ordernumber)
      }
    }
    this.opnekickOut = true
  }

  private initiate: boolean = false
  private ordernumber: any = []
  private openInitiate() {
    let falg = this.selectList.every(item => {
      if (item.status === 1) {
        return true
      }
    })
    let success = this.selectList.every(item => {
      if (item.extra_param.cap_status === '1') {
        return true
      }
    })

    if (!falg || success) {
      this.initiate = true
    } else {
      this.selectList.map(item => {
        if (item.status === 1) {
          this.ordernumber.push(item.ordernumber)
        }
      })
      this.setInitiateStatus()
    }
  }
  private colseInitiate() {
    this.initiate = false
    this.ordernumber = []
  }
  private async setInitiateStatus() {
    try {
      await batchOrderCap({
        ordernumbers: this.ordernumber
      }).then(() => {
        this.flagStr()
        this.loading = false
        // this.initiate = false
        this.$message.success('Successful operation!')
        this.ordernumber = []
        this.hadleGetFilesListApi()
      })
    } catch (e) {
      this.loading = false
      // this.initiate = false
    }
  }

  private getTimeStamp(val) {
    this.fixTime = val
    this.setForm.paid_time = dateToSeconds(this.fixTime)
  }

  private immediUpdate(e) {
    this.$nextTick(() => {
      if (e == null) {
        this.setForm.paid_time = ''
      }
    })
  }

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private salaryChange(e) {
    this.queryForm.pay_time_duration = e.target.value
  }

  // 修改订单获取产品账户
  private changeOrderAccountList: any[] = []
  private orderProductAccount: any = ''
  private async getOrderProductAccountList(name) {
    try {
      const data = {
        product_code: this.setForm.product_code,
        name: name,
        page_size: 100
      }
      await getProductAccountList(data).then((res: any) => {
        this.changeOrderAccountList = res.results
      })
    } catch (e) {}
  }

  private editLoading: boolean = false
  private async setOrderStatus() {
    ;(this.$refs.setForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.editLoading = true
        this.flag = true
        let {
          ordernumber,
          // product_account,
          status,
          remarks,
          description,
          paid_time,
          attach,
          upstream_ordernumber,
          product_sub_code
        } = this.setForm

        const data: any = {
          ordernumber,
          status,
          remarks,
          description,
          paid_time,
          attach,
          upstream_ordernumber,
          product_account: this.orderProductAccount,
          product_sub_code: product_sub_code
        }
        try {
          if (this.setForm.oldStatus === 0) {
            // 未支付 => 支付
            await setUnpaidOrder(data).then(() => {
              operationMessage(
                checkNeedAudit('change_unpaid_deposit_order_status') !==
                  undefined
              )
              this.flagStr()
              this.editLoading = false
            })
          } else {
            await setPaidOrder(data).then(() => {
              operationMessage(
                checkNeedAudit('change_paid_deposit_order_status') !== undefined
              )
              this.flagStr()
              this.editLoading = false
            })
          }
          this.closeDialog()
        } catch (e) {
          this.editLoading = false
          this.flagStr()
        }
      }
    })
  }

  private openDrawer(row: any) {
    this.currentOrdernumber = row.ordernumber
    this.drawer = true
  }

  private closeDrawer(isManual: boolean = false) {
    if (isManual) {
      this.drawer = false
    }
    this.currentOrdernumber = null
    // this.hadleGetFilesListApi()
  }

  // 退款弹窗
  private refundLoading: boolean = false
  private refundForm: any = {}
  private refundAmount: any = ''
  private openRefund(row: any) {
    this.refundLoading = true
    this.refundForm = row
    this.refundAmount = row.amount
  }
  private async saveRefund() {
    ;(this.$refs.refundForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true
        this.flag = true
        const data: any = {
          ordernumber: this.refundForm.ordernumber,
          amount: this.refundAmount,
          remarks: this.refundForm.remarks,
          google_code: this.refundForm.google_code
        }
        await depositRefund(data)
          .then(() => {
            this.flagStr()
            this.loading = false
            this.refundLoading = false
            this.closeRefund()
            this.hadleGetFilesListApi()
          })
          .catch(() => {
            this.loading = false
            this.refundLoading = false
            this.flagStr()
          })
      } else {
        return false
      }
    })
  }
  private closeRefund() {
    this.refundLoading = false
    this.refundForm = {}
  }

  private currencyChange() {
    AppModule.SetCurrentCurrencyType(this.queryForm.currency)
    this.reset()
  }

  private versionChange(v) {
    this.hadleGetFilesListApi()
    this.depositOrderStatistical()
  }

  private async reset() {
    await this.checkChildProduct()
    this.queryForm = {
      currency: this.queryForm.currency,
      upstream_remarks: null,
      last4: null,
      auth_code: null,
      merchant_no: null,
      order_number: null,
      ant_username: null,
      start_time: null,
      end_time: null,
      status: null,
      upstream_status: null,
      notify_status: null,
      product: null,
      notify_start_time: null,
      notify_end_time: null,
      product_code: null,
      product_account_no: null,
      min_amount: '',
      max_amount: '',
      min_request_amount: '',
      max_request_amount: '',
      success_start_time: null,
      success_end_time: null,
      product_type: 'deposit',
      product_account_group: null,
      test_order: null,
      kaaz_bank: null,
      pay_time_duration: null
    }
    this.dateType = 'Created Time'
    this.date = getCurrentDate()
    this.notifyDate = getCurrentDate()
    this.successDate = getCurrentDate()
    this.currentPage = 1
    await this.hadleGetFilesListApi()
    await this.depositOrderStatistical()
  }

  private select() {
    this.currentPage = 1
    this.hadleGetFilesListApi()
    this.depositOrderStatistical()
  }

  // 入金订单统计
  private async depositOrderStatistical() {
    try {
      let data: any = {
        ...this.queryForm
      }
      await depositOrderStatistical(data).then((res: any) => {
        this.totalData = res
      })
    } catch (e) {}
  }

  private async exportData() {
    try {
      this.sendLoading = true
      const data: any = {
        ...this.queryForm
      }
      delObjEmptyKey(data)
      await orderExport(data).then(() => {
        this.$message({
          message: 'The form has been sent to your mailbox, please check it!',
          type: 'success'
        })
        this.sendLoading = false
      })
    } catch (e) {
      this.sendLoading = false
      this.$message({
        message: 'Export failure!',
        type: 'error'
      })
    }
  }

  private queryName: any = ''
  private productNameChange() {
    this.queryForm.product_account_group = ''
    this.getProductAccountGroup(this.queryName)
  }

  // 远程查询
  private accountGroupList: any[] = []
  private async getProductAccountGroup(query: string) {
    this.queryName = query
    try {
      const data = {
        currency: this.queryForm.currency,
        product_code: this.queryForm.product_code,
        name: query,
        page_size: 50
      }
      await getAccountGroupList(data).then((res: any) => {
        this.accountGroupList = res.results
      })
    } catch (e) {}
  }

  private getTypeStatus(id) {
    let arr = this.upstreamStatusList.filter(item => {
      if (id === item.id) {
        return item
      }
    })
    return arr[0]
  }

  private async init() {
    this.orderStatusList = await AppModule.GetOrderStatusList()
    this.upstreamStatusList = await AppModule.GetUpstreamStatusList()

    await AppModule.GetConstant().then((res: any) => {
      this.statusList = res.IN_ORDER_STATUS_CHOICES
    })
    this.hadleGetFilesListApi()
    this.depositOrderStatistical()
  }

  private dataInfo: any = []
  private dataVisible: boolean = false
  private openMoreDialog(row) {
    this.dataInfo = jsonToObjArr(row)
    this.dataVisible = true
  }
  private closeData() {
    this.dataVisible = false
  }

  private siteName = this.$store.state.app.enterprise.ssl_switch.site_name
  private systemName: any = 'Admin System'
  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
  private systemLogo: any = ''

  mounted() {
    ;(window as any).jumpAddress = this.jumpAddress
    ;(window as any).jumpUSDCAddress = this.jumpUSDCAddress
    ;(window as any).bit2goJump = this.bit2goJump
    this.init()
    this.sysType = getType()
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
      document.title = this.siteName + ' ' + this.$t(`route.operation`)
    } else {
      AppModule.SetSiteName(this.systemName)
      document.title = this.$t(`route.deposit`) + '- Admin System'
    }
    if (this.sitelogo && this.sitelogo !== '') {
      AppModule.SetSiteLogo(this.sitelogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.sitelogo
      document.getElementsByTagName('head')[0].appendChild(link)
    } else {
      AppModule.SetSiteLogo(this.systemLogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.systemLogo
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }
}
